import React from 'react'

interface PreferencesSectionHeaderProps {
  title: React.ReactNode
  description?: React.ReactNode
  className?: string
  withBorder?: boolean // default: true
  paddingClassName?: string // default: 'p-6'
  titleClassName?: string // optional override for title size
  descriptionClassName?: string // optional override for description size
}

/**
 * Reusable section header for user preferences pages.
 * Renders a header with optional border and padding, title and optional description.
 */
export function PreferencesSectionHeader({
  title,
  description,
  className,
  withBorder = true,
  paddingClassName = 'p-6',
  titleClassName,
  descriptionClassName,
}: PreferencesSectionHeaderProps) {
  const classes = [
    'flex flex-col gap-1.5',
    withBorder ? 'border-b border-base-border' : '',
    paddingClassName,
    className,
  ]
    .filter(Boolean)
    .join(' ')

  return (
    <div className={classes}>
      <h2 className={['text-lg font-semibold', titleClassName].filter(Boolean).join(' ')}>{title}</h2>
      {description ? (
        <p className={['text-sm font-normal text-muted-foreground', descriptionClassName].filter(Boolean).join(' ')}>
          {description}
        </p>
      ) : null}
    </div>
  )
}
